// THE SETUP'S GATE on the app builder (functions/workspaceSetup.js — the
// workspace builds itself in front of the person, lane WS1). A display:none
// div whose job is a reactive check, the shape of OnboardingGate: on mount it
// reads Fly's hand-over mark, then every change it follows runs the setup's
// prime — the read and its poll, the navigation refresh as apps land, the
// first thread, the first build. A tab that comes back from hidden asks again
// at once (the poll asks nothing while the tab is hidden).
//
// It sits on the builder PAGE (pages/add-app.js), so its scope is the page's:
// `addAppThreadInUrl: false` says the builder is the home's Build tab, not the
// route (functions/homeBuild.js).
export const WorkspaceSetupGate = {
  tag: 'div',
  display: 'none',
  ariaHidden: 'true',
  subscribeTo: [
    'workspace',
    'workspaceReady',
    'user',
    'userPrefs',
    'bridgeStatus',
    '_workspaceSetup',
    '_ax_activeSessionId',
    '_addAppProjectId',
    '_creditGuard',
    '_wsAppsCatalog'
  ],
  onCreate: (el, s) => el.call('workspaceSetupPrime', el, s),
  onUpdate: (el, s) => el.call('workspaceSetupPrime', el, s),
  onDocumentVisibilityChange: (e, el, s) => el.call('workspaceSetupPrime', el, s, { wake: true })
}
